export enum ScreenSize {
  mobile = '480px'
}
